import { ThemeEvents } from '@theme/events';

class ProductDetailsTabs extends HTMLElement {
  /** @type {NodeListOf<HTMLButtonElement>} */
  get tabs() {
    return this.querySelectorAll('[role="tab"]');
  }

  /** @type {NodeListOf<HTMLElement>} */
  get panels() {
    return this.querySelectorAll('[role="tabpanel"]');
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.#handleTabClick, { signal });
    });

    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleTabClick = (event) => {
    const clickedTab = event.currentTarget;
    const index = clickedTab.dataset.tabIndex;

    this.tabs.forEach((tab) => {
      const isSelected = tab.dataset.tabIndex === index;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabIndex !== index;
    });
  };

  #handleVariantUpdate = (event) => {
    const newHtml = event.detail.data.html;
    if (!newHtml) return;

    const newSpecs = newHtml.querySelectorAll('.product-details-tabs__specs');
    const currentSpecs = this.querySelectorAll('.product-details-tabs__specs');

    currentSpecs.forEach((currentSpec, index) => {
      const newSpec = newSpecs[index];
      if (newSpec && currentSpec.innerHTML !== newSpec.innerHTML) {
        currentSpec.innerHTML = newSpec.innerHTML;
      }
    });
  };
}

if (!customElements.get('product-details-tabs')) {
  customElements.define('product-details-tabs', ProductDetailsTabs);
}
